import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import adminApiClient, { ClockFieldWatch } from "../../../api/admin";

const QUERY_KEY = ["clock-field-watches"];

export const useClockFieldWatches = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => adminApiClient.getClockFieldWatches(),
    refetchInterval: 30000,
  });
};

export const useCreateClockFieldWatch = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<ClockFieldWatch>) =>
      adminApiClient.createClockFieldWatch(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};

export const useDeleteClockFieldWatch = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminApiClient.deleteClockFieldWatch(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};

export const useSetClockFieldWatchActive = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, active }: { id: string; active: boolean }) =>
      adminApiClient.setClockFieldWatchActive(id, active),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
